import React from 'react';
import { CommonIconProps } from './Icon';

const XThinIcon = ({ color }: CommonIconProps): JSX.Element => (
  <>
    <path
      d="M1.35962 10.4528L10.453 1.35938M10.453 10.6402L1.35962 1.54676"
      stroke={color}
      strokeWidth="1.14"
      strokeLinecap="round"
    />
  </>
);

export default XThinIcon;

XThinIcon.prototype.svgPropOverrides = { viewBox: '0 0 12 12' };
